import React, { useRef , useState }  from "react";
import { createRoot } from "react-dom/client"; // <-- IMPORT arriba
import PlayerDropboxNew from './PlayerDropboxNew'
import { useTranslation } from 'react-i18next';
import Mailer from './Mailer';


function ContactNew(){
    const { t, i18n } = useTranslation();
     const containerRef = useRef(null);
 const [fadeOut, setFadeOut] = useState(false);

const handleClick = () => {
    if (containerRef.current) {
      containerRef.current.innerHTML = ""; // limpia la imagen
      const root = createRoot(containerRef.current); // renderiza el video
      root.render(<PlayerDropboxNew source="https://www.dropbox.com/scl/fi/izk94td7uczycjwj9n45x/CAR-engine.mp4?rlkey=paqfnn0ccqagitjv17jevka8r&st=4a8xnuda&dl=0"/>);
    }
    setFadeOut(true);
  };
   




    return(
      <div className="overlay-content" >

               <Mailer/>
                


      </div>
    )
}
export default ContactNew